/**
 * INFO: Level logic mostly implemented by Konstantin.
 */

import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import Level, { levelActionCreator, LevelActionsAction } from '../../Inamove/Components/Level'
import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import Config from '../../Inamove/Containers/Config'
import dispatch from '../../Inamove/Utility/dispatchAction'
import { waypointOpenActionCreator } from '../../Inamove/Components/Waypoint'
import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import { toggleKulissen, playVideo } from '../../KUtil/help'
import LoadingController from '../../Inamove/Controllers/LoadingController'

const levelId = 'level10'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    //definitions
    const vorStrommastKulisse = level.gameScenes.K143

    const torKulissenLaut = [
        level.gameScenes.K145,
        level.gameScenes.K146,
        level.gameScenes.K153,
        level.gameScenes.K154,
        level.gameScenes.K155,
        level.gameScenes.K156,
        level.gameScenes.K158,
    ]

    const torKulissenLeise = [
        level.gameScenes.K146A,
        level.gameScenes.K155A,
        level.gameScenes.K156A,
        level.gameScenes.K153A,
    ]

    //load video
    const IntroVIdeo = new Video(Config.CINEMATIC_PATH + 'V22-anfang-burg' + Config.VIDEO_FILE_EXT)
    const ScheunenVideo = new Video(Config.CINEMATIC_PATH + 'V24' + Config.VIDEO_FILE_EXT)
    const V25 = new Video(Config.CINEMATIC_PATH + 'V25' + Config.VIDEO_FILE_EXT)
    const verschlossenVideo = new Video(Config.CINEMATIC_PATH + 'burg-verschlossen-1' + Config.VIDEO_FILE_EXT)
    const nachLoesungVideo = new Video(Config.CINEMATIC_PATH + 'burg-verschlossen-nach-loesung' + Config.VIDEO_FILE_EXT)

    ;[IntroVIdeo, ScheunenVideo, V25, verschlossenVideo, nachLoesungVideo].forEach(LoadingController.addToQueue)

    CinematicContainer.setVideo(IntroVIdeo)

    //load graphics
    const Lamp_Aus_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K150/Lampe-aus.png')
    const Lamp_An_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K150/Lampe-an.png')
    const K152_Stromkasten_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K152/K152-overlay-kabel.png')
    const K151_Stromkasten_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K151/K151-overlay-kabelbruch.png')

    ;[Lamp_An_Overlay, Lamp_Aus_Overlay, K152_Stromkasten_Overlay, K151_Stromkasten_Overlay].forEach(
        LoadingController.addToQueue
    )

    const nachKabelKappenAudio = AudioController.add(
        Config.GAME_SCENE_PATH + 'K152/audio/K152-nach-kabel-kappen' + Config.AUDIO_FILE_EXT
    )

    //Prepare level
    level.gameScenes.K152.addImage(K152_Stromkasten_Overlay)
    level.gameScenes.K150.addImage(Lamp_An_Overlay)

    level.gameScenes.K155.showInteractableObject('tür')
    level.gameScenes.K155.hideInteractableObject('tür1')
    level.gameScenes.K155.hideInteractableObject('tür2')

    //Verstecke "ruhige" Wegpunkte
    const ruhigeKulissen = ['K146A', 'K153A', 'K154A', 'K155A', 'K156A']
    const lauteKulissen = ['K146', 'K153', 'K154', 'K155', 'K156']

    toggleKulissen(torKulissenLaut, ruhigeKulissen, false)

    vorStrommastKulisse.hideWaypoint('K151')

    createInteractableObjectListener('tür', async () => {
        await playVideo(verschlossenVideo)
        //Ändere Reaktion an Tür
        level.gameScenes.K155.hideInteractableObject('tür')
        level.gameScenes.K155.showInteractableObject('tür1')
        //Wegpunkte zu Strommast freischalten
        toggleKulissen([vorStrommastKulisse], ['K151'], true)
        dispatch(waypointOpenActionCreator('K151'))
    })

    createInteractableObjectListener('tür2', async () => {
        level.stopGame(true)
        await playVideo(nachLoesungVideo)
        await playVideo(ScheunenVideo)

        // Spieler zu Kulisse mit offener Scheune teleportieren
        level.startGame('K159')
        //K154(A) sperren und dafür K159 entsperren
        toggleKulissen(torKulissenLeise, ['K154', 'K154A'], false)
        toggleKulissen(torKulissenLeise, ['K159'], true)
    })

    createInteractableObjectListener('kabel', () => {
        level.gameScenes.K152.removeImage(K152_Stromkasten_Overlay)
        level.gameScenes.K151.addImage(K151_Stromkasten_Overlay)
        level.gameScenes.K150.addImage(Lamp_Aus_Overlay)
        level.gameScenes.K150.removeImage(Lamp_An_Overlay)

        //Staubsauger aus
        toggleKulissen(torKulissenLaut, lauteKulissen, false)
        toggleKulissen(torKulissenLaut, ruhigeKulissen, true)

        //An der Tür wird aufgemacht
        level.gameScenes.K155.hideInteractableObject('tür1')
        level.gameScenes.K155.showInteractableObject('tür2')

        AudioController.play(nachKabelKappenAudio)
    })

    // level end condition
    createInteractableObjectListener(
        'sofa',
        async () => {
            await playVideo(V25)
            dispatch(levelActionCreator(level, LevelActionsAction.stop))
        },
        true
    )

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    CinematicContainer.show()
    await CinematicContainer.play()
    CinematicContainer.hide()
    GameSceneContainer.show()
    InventoryContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === levelId) {
                resolve()
            }
        })
    })
}
